import moment from 'moment'

export const formatHour = (hour: number, min: number) => {
  const date = moment().format('YYYY-MM-DD') // Obtén la fecha actual en formato YYYY-MM-DD
  const dateTimeString = `${date} ${hour}:${min}` // Combina la fecha y la hora
  const formattedTime = moment(dateTimeString, 'YYYY-MM-DD HH:mm')
  const formattedTimeString = formattedTime.format('hh:mm A')
  return formattedTimeString
}
